export default "__VITE_ASSET__7db974c2__"